import api from "./api";

export const postChangePassword = async (body) => {
  return api
    .post({
      body,
      endpoint: "/owner/change-password",
      port: process.env.REACT_APP_PORT_OWNER,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
